import type {
  IFilterData,
  IFilterDataArray,
  IFilterOption,
} from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { FiltersColumns } from '../constants'

type UserStateColumn = IFilterOption & { key?: string }

function isUserStateRow(row: IFilterDataArray): boolean {
  return row.selectedValueData?.key === FiltersColumns.userState
}

function syncUserStateRows(
  rows: IFilterDataArray[] | undefined,
  userStateColumn: UserStateColumn
): { rows: IFilterDataArray[] | undefined; changed: boolean } {
  if (!rows?.length) return { rows, changed: false }

  let changed = false
  const nextRows = rows.map((row) => {
    if (!isUserStateRow(row)) return row
    if (
      row.input === userStateColumn.value &&
      row.selectedValueData === userStateColumn
    ) {
      return row
    }
    changed = true
    return {
      ...row,
      input: userStateColumn.value as IFilterDataArray['input'],
      selectedValueData: userStateColumn,
    }
  })

  return { rows: nextRows, changed }
}

export function buildDefaultActiveUserFilter(
  userStateColumn?: IFilterOption
): IFilterData | undefined {
  if (!userStateColumn) return undefined

  return {
    data: [
      {
        group: 0,
        input: userStateColumn.value as IFilterDataArray['input'],
        selectedValueData: userStateColumn,
        type: 'tagsList',
        operator: 'eq',
        compareTo: 'true',
        index: 0,
        condition: 'and',
      },
    ],
    generalCondition: 'and',
    filterType: 'simple',
  }
}

export function syncUserStateFilterColumn(
  filterData: IFilterData | undefined,
  userStateColumn?: UserStateColumn
): IFilterData | undefined {
  if (!userStateColumn) return filterData
  if (!filterData) return buildDefaultActiveUserFilter(userStateColumn)

  const syncedData = syncUserStateRows(filterData.data, userStateColumn)
  if (!syncedData.changed) return filterData

  return {
    ...filterData,
    data: syncedData.rows,
  }
}
